var translate = require('../../locale/index.js');

$(function() {
  translate();
  
});
